jQuery( document ).ready(function() {

  if($('.duopraticientxt_box').length > 0) {

    var counter = 0
    $(".duopraticientxt_item").each(function() {
        var i = 0;
        $($(this).find(".duopraticientxt_specialite")).each(function(){
            console.log(counter);
            if ($(this).text() == $("#current_specialite").val()) {
                i = i + 1;

                if (counter>3) {
                    $(this).parent().remove();
                    counter++;
                } else {
                    counter++;
                }
            } 
        });

        if (i == 0) {
            $(this).addClass("hidden");
        }

    });

    $(".duopraticientxt_item.hidden").each(function() {
        $(this).remove();
    });

  }

    if( $('.detail_praticien_specialites').length > 0 ) { 
        $('.detail_praticien_specialites').owlCarousel({
            loop: false,
            nav: true,
            items: 1,
            dots: false,
            responsive : {
                // breakpoint from 0 up
                0 : {
                    nav: false,
                },
                // breakpoint from 425 up
                1000 : {
                    navText: ["<i class='nav-left-owl'>","<i class='nav-right-owl'>"],
                    nav: true,
                }
            }
        });
    }


});